import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { AIConfig } from '../../models/ai-config.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-ai-modal',
  templateUrl: './ai-modal.component.html',
  styleUrls: ['./ai-modal.component.less'],
})
export class AIModalComponent implements OnChanges {
  @Input() config: AIConfig;
  @Input() isOpen: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  safeIframeUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config'] && this.config && this.config['iframeUrl']) {
      this.safeIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.config['iframeUrl'],
      );
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closeModal.emit();
    }
  }
}
